import { HttpApiSchema } from "@effect/platform";
import { Schema } from "effect";
import { BlockedSendResult } from "./block-rule";

export class MessageSendBlockedError extends Schema.TaggedError<MessageSendBlockedError>()(
  "MessageSendBlockedError",
  { blocked: BlockedSendResult },
  HttpApiSchema.annotations({ status: 403 }),
) {}
